export const SEARCH_QUERY_KEY = 'q';

export function toQueryParam(key: string): string {
    return key === SEARCH_QUERY_KEY ? SEARCH_QUERY_KEY : `f_${key}`;
}

export function fromQueryParam(key: string): string {
    if (key === SEARCH_QUERY_KEY) return SEARCH_QUERY_KEY;
    if (key.startsWith('f_')) return key.slice(2);
    return key;
}
